import { useRef, useEffect, useState } from 'react';

import UpcomingGrant from '../../../components/grants/upcoming-grant';

export default ({ ref = useRef(null), setPopup, items }) => {
    const clicked = () => setPopup(null);

    const outsideClick = (event) => {
        if (ref.current && !ref.current.contains(event.target)) clicked();
    }

    useEffect(() => {
        window.addEventListener('click', outsideClick);

        return () => {
            window.removeEventListener('click', outsideClick);
        }
    }, []);
    
    return (
        <div className="side-popup__outer">
            <div class="progress-popup side-popup" ref={ref}>
                <div className="utils__row utils__rowSpaceBetween">
                    <h1>Application Activity</h1>
                   <span className="side-popup__close" onClick={clicked}>
                       <img src="/assets/close.svg" />
                   </span>
                </div>
                <div className="progress__content">
                    <p className="progress__title">Application History</p>
                    <div className="progress__inner">
                    {
                        items.map((item, index) => {
                            return(
                                <UpcomingGrant key={index} {...item} />
                            );
                        })
                    }
                    </div>
                </div>
            </div>
        </div>
    )
}